// App.js — DateBot rotası eklendi
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import { NotificationProvider } from './components/NotificationProvider';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bots from './pages/Bots';
import Applications from './pages/Applications';
import Broadcast from './pages/Broadcast';
import Chat from './pages/Chat';
import Users from './pages/Users';
import Notifications from './pages/Notifications';
import Tickets from './pages/Tickets';
import Analytics from './pages/Analytics';
import Profiles from './pages/Profiles';
import MailSender from './pages/MailSender';
import Affiliate from './pages/Affiliate';
import NewsBot from './pages/NewsBot';
import TelegramClient from './pages/TelegramClient';
import Retargeting from './pages/Retargeting';
import DateBot from './pages/DateBot';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';

function PrivateRoute({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" replace />;
}

function AuthenticatedApp() {
  return (
    <NotificationProvider>
      <Routes>
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="bots" element={<Bots />} />
          <Route path="chat" element={<Chat />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="applications" element={<Applications />} />
          <Route path="broadcast" element={<Broadcast />} />
          <Route path="profiles" element={<Profiles />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="users" element={<Users />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="mail" element={<MailSender />} />
          <Route path="affiliate" element={<Affiliate />} />
          <Route path="news-bot" element={<NewsBot />} />
          <Route path="telegram" element={<TelegramClient />} />
          <Route path="retargeting" element={<Retargeting />} />
          <Route path="datebot" element={<DateBot />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </NotificationProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<ErrorBoundary><AuthenticatedApp /></ErrorBoundary>} />
      </Routes>
    </BrowserRouter>
  );
}

// ─────────────────────────────────────────────────────────
// Layout.js — NavItems listesine DateBot eklendi
// Aşağıdaki satırı navItems dizisine ekle:
// { to:'/datebot', icon:'💕', label:'Date Bot' }
// ─────────────────────────────────────────────────────────
